
import {
  defineComponent,
  ref,
  onMounted,
  onUnmounted,
  nextTick,
  PropType,
  Ref
} from "vue";

export default defineComponent({
  name: "CustomDropdown",
  props: {
    items: {
      type: Array as PropType<
        {
          label: string;
          description: string;
          action?: () => void;
          disabled?: boolean;
          icon?: string;
        }[]
      >,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  },

  setup(props) {
    const showOptions = ref(false);
    const dropdownRef = ref<HTMLElement | null>(null);
    const dropdownMenu: Ref<HTMLUListElement | null> = ref(null);
    validateItems(props.items);

    function toggleOptions() {
      showOptions.value = !showOptions.value;
      if (showOptions.value) {
        adjustDropdownPosition();
      }
    }

    async function adjustDropdownPosition() {
      nextTick(() => {
        if (dropdownMenu.value) {
          const rect = dropdownMenu.value.getBoundingClientRect();
          const viewportWidth = window.innerWidth;

          if (rect.right > viewportWidth) {
            dropdownMenu.value.style.left = "auto";
            dropdownMenu.value.style.right = "0";
          } else if (rect.left < 0) {
            dropdownMenu.value.style.left = "0";
            dropdownMenu.value.style.right = "auto";
          }
        }
      });
    }

    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.value &&
        !dropdownRef.value.contains(event.target as Node)
      ) {
        showOptions.value = false;
      }
    }

    function handleClick(item: any) {
      showOptions.value = false;
      item.action?.();
    }

    function validateItems(
      items: Array<{
        label: string;
        description: string;
        action?: () => void;
        disabled?: boolean;
      }>
    ) {
      const isValid = items.every(item =>
        ["label", "description", "action", "disabled"].every(key => key in item)
      );

      if (!isValid) {
        console.warn("Invalid items structure passed to CustomDropdown");
      }
    }

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
      window.addEventListener("resize", adjustDropdownPosition);
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
      window.removeEventListener("resize", adjustDropdownPosition);
    });

    return {
      showOptions,
      dropdownRef,
      dropdownMenu,
      toggleOptions,
      handleClick
    };
  }
});
